module.exports = "<div class=\"holder-data\"><ng-content select=\"\"></ng-content></div>";